import api from '@/apis'

export const getProduct = (id, params) => api.get(`/products/${id}`, { params })
export const fetchList = (params) => api.get(`/findAllProducts`, { params })
export const setActiveState = (id, isActive) => api.put(`/products/${id}/delete`, { isActive })
